/**
 * Observed actuals for the planned-vs-actual widget (5.1.1): in-home minutes and
 * drive minutes per visit type over the trailing eight weeks. The demo tenant has
 * no history, so these stand in for the KPI query; the shape is what the real
 * widget would read from visit event logs and drive fields.
 */
import type { VisitTypeKind } from "@caredna-marlin/utils/homeHealthDemo/state";

export interface ObservedVisitType {
  kind: VisitTypeKind;
  observedInHomeMinutes: number;
  observedDriveMinutes: number;
  sampleSize: number;
}

export const OBSERVED_TRAILING_WEEKS = 8;

export const OBSERVED_BY_KIND: ObservedVisitType[] = [
  { kind: "SOC", observedInHomeMinutes: 148, observedDriveMinutes: 34, sampleSize: 41 },
  { kind: "ROC", observedInHomeMinutes: 101, observedDriveMinutes: 29, sampleSize: 12 },
  { kind: "RECERT", observedInHomeMinutes: 104, observedDriveMinutes: 27, sampleSize: 19 },
  { kind: "DISCHARGE_ASSESSMENT", observedInHomeMinutes: 71, observedDriveMinutes: 26, sampleSize: 23 },
  { kind: "SN_ROUTINE", observedInHomeMinutes: 44, observedDriveMinutes: 18, sampleSize: 612 },
  { kind: "RN_SUPERVISORY", observedInHomeMinutes: 27, observedDriveMinutes: 15, sampleSize: 38 },
  { kind: "PT_EVAL", observedInHomeMinutes: 57, observedDriveMinutes: 24, sampleSize: 44 },
  { kind: "PT_ROUTINE", observedInHomeMinutes: 43, observedDriveMinutes: 19, sampleSize: 388 },
  { kind: "OT_EVAL", observedInHomeMinutes: 59, observedDriveMinutes: 25, sampleSize: 15 },
  { kind: "OT_ROUTINE", observedInHomeMinutes: 46, observedDriveMinutes: 20, sampleSize: 121 },
  { kind: "SLP_EVAL", observedInHomeMinutes: 62, observedDriveMinutes: 26, sampleSize: 6 },
  { kind: "SLP_ROUTINE", observedInHomeMinutes: 48, observedDriveMinutes: 21, sampleSize: 47 },
  { kind: "MSW_VISIT", observedInHomeMinutes: 66, observedDriveMinutes: 28, sampleSize: 29 },
  { kind: "HHA_VISIT", observedInHomeMinutes: 58, observedDriveMinutes: 16, sampleSize: 402 },
];
